fragment UpsellFragment on upsell_Entry {
  typeHandle
  heading
  bulletpoints {
    ... on bulletpointsBlock_Entry {
      point
    }
  }
  ctaBar
  ctaLightGreen
  ctaBarAction
  ctaBarHeading

  upsellProduct
  discountCode
  discountValue
  discountType
}
